import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS } from '../../../constants/Tracking';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { PlaylistCard, SavedItemsPagedList, useFilteredMyPlaylists } from '../../../features/savedItems';
const MY_PLAYLISTS_FILTERS = [FILTER_TYPES.CREATED_BY]; // displays only initial playlists on page load

const useInitialPlaylists = () => {
  const {
    totalPlaylists,
    playlists,
    page,
    playlistsLoading,
    selectedCreatedBy,
    searchFilter
  } = useFilteredMyPlaylists();
  const [playlistsToDisplay, setPlaylistsToDisplay] = useState(null);
  const [displayedTotalPlaylists, setDisplayedTotalPlaylists] = useState(0); // changing page or filters resets initial data load reference

  useEffect(() => {
    setPlaylistsToDisplay(null);
    setDisplayedTotalPlaylists(0);
  }, [page, selectedCreatedBy, searchFilter]);
  useEffect(() => {
    if (!playlistsLoading && !playlistsToDisplay) {
      setPlaylistsToDisplay(playlists);
      setDisplayedTotalPlaylists(totalPlaylists);
    }
  }, [playlists, playlistsLoading, playlistsToDisplay, totalPlaylists]);
  return {
    playlistsToDisplay,
    displayedTotalPlaylists
  };
};

const MyPlaylistsList = () => {
  const {
    hasFilters,
    playlists,
    page,
    playlistsLoading,
    playlistsError
  } = useFilteredMyPlaylists();
  const {
    playlistsToDisplay,
    displayedTotalPlaylists
  } = useInitialPlaylists();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.MY_PLAYLISTS
    });
  }, []);
  const isGhost = useCallback(playlistId => {
    return playlists !== null && !playlists.some(p => p.id === playlistId);
  }, [playlists]);
  return /*#__PURE__*/_jsx(SavedItemsPagedList, {
    alwaysShowFilters: true,
    error: playlistsError,
    filters: MY_PLAYLISTS_FILTERS,
    hasError: !!playlistsError,
    hasItems: displayedTotalPlaylists > 0 || hasFilters // having filters means there are playlists
    ,
    isLoadingPageOnDemand: true,
    isRequesting: playlistsLoading,
    itemKey: "myPlaylists",
    list: playlistsToDisplay && playlistsToDisplay.map(({
      id
    }, index) => /*#__PURE__*/_jsx(PlaylistCard, {
      isGhost: isGhost(id),
      playlistId: id
    }, index)),
    markerKey: "MY_PLAYLISTS",
    page: page,
    totalCount: displayedTotalPlaylists
  });
};

export default MyPlaylistsList;